/**
 * Liens sortants vers un artiste : des pages de recherche, aucune API tierce (spec, 3.2).
 * Les liens s'ouvrent dans un nouvel onglet avec rel="noopener noreferrer" : le site
 * visite ne recoit ni la page d'origine ni un acces a la fenetre.
 */
export interface ArtistLink {
  id: "spotify" | "deezer" | "youtube";
  label: string;
  href: string;
}

export const LINK_REL = "noopener noreferrer";

export function artistLinks(name: string): ArtistLink[] {
  const q = encodeURIComponent(name);
  return [
    { id: "spotify", label: "Spotify", href: `https://open.spotify.com/search/${q}` },
    { id: "deezer", label: "Deezer", href: `https://www.deezer.com/search/${q}` },
    {
      id: "youtube",
      label: "YouTube",
      href: `https://www.youtube.com/results?search_query=${q}`,
    },
  ];
}
